module.exports = __webpack_public_path__ + "img/metal_ao@2x.91e9d116.png";